// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
.service-detail {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
    font-family: "Poppins", sans-serif;
    color: #333;
    line-height: 1.6;
  }
  
  /* Title */
  .service-detail h1 {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;
    color: #2c3e50;
    text-align: center;
  }
  
  /* Description */
  .service-detail p {
    font-size: 1.1rem;
    color: #555;
    margin-bottom: 30px;
    text-align: center;
  }
  
  /* Details List */
  .service-detail ul {
    list-style-type: none;
    padding: 0;
    margin: 0 auto;
    max-width: 800px;
  }
  
  .service-detail ul li {
    background: #f9f9f9;
    margin-bottom: 15px;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-size: 1rem;
    color: #444;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .service-detail ul li:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  
  /* Back Link */
  .back-link {
    display: inline-block;
    margin-top: 40px;
    padding: 10px 20px;
    background: #667eea;
    color: white;
    text-decoration: none;
    border-radius: 5px;
    font-size: 1rem;
    font-weight: 500;
    transition: background 0.3s ease, transform 0.3s ease;
  }
  
  .back-link:hover {
    background: #764ba2;
    transform: translateY(-3px);
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .service-detail h1 {
      font-size: 2rem;
    }
  
    .service-detail p {
      font-size: 1rem;
    }
  
    .service-detail ul li {
      font-size: 0.9rem;
      padding: 10px;
    }
  
    .back-link {
      font-size: 0.9rem;
      padding: 8px 16px;
    }
  }
  
  @media (max-width: 480px) {
    .service-detail h1 {
      font-size: 1.8rem;
    }
  
    .service-detail p {
      font-size: 0.9rem;
    }
  
    .service-detail ul li {
      font-size: 0.8rem;
    }
  
    .back-link {
      font-size: 0.8rem;
      padding: 6px 12px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/ServiceDetailPage.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;IACX,gBAAgB;EAClB;;EAEA,UAAU;EACV;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,qBAAqB;IACrB,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,WAAW;IACX,qDAAqD;EACvD;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA,cAAc;EACd;IACE,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qDAAqD;EACvD;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA,sBAAsB;EACtB;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;MACjB,aAAa;IACf;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF","sourcesContent":["/* General Styles */\n.service-detail {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 40px 20px;\n    font-family: \"Poppins\", sans-serif;\n    color: #333;\n    line-height: 1.6;\n  }\n  \n  /* Title */\n  .service-detail h1 {\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin-bottom: 20px;\n    color: #2c3e50;\n    text-align: center;\n  }\n  \n  /* Description */\n  .service-detail p {\n    font-size: 1.1rem;\n    color: #555;\n    margin-bottom: 30px;\n    text-align: center;\n  }\n  \n  /* Details List */\n  .service-detail ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0 auto;\n    max-width: 800px;\n  }\n  \n  .service-detail ul li {\n    background: #f9f9f9;\n    margin-bottom: 15px;\n    padding: 15px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    font-size: 1rem;\n    color: #444;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .service-detail ul li:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  }\n  \n  /* Back Link */\n  .back-link {\n    display: inline-block;\n    margin-top: 40px;\n    padding: 10px 20px;\n    background: #667eea;\n    color: white;\n    text-decoration: none;\n    border-radius: 5px;\n    font-size: 1rem;\n    font-weight: 500;\n    transition: background 0.3s ease, transform 0.3s ease;\n  }\n  \n  .back-link:hover {\n    background: #764ba2;\n    transform: translateY(-3px);\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .service-detail h1 {\n      font-size: 2rem;\n    }\n  \n    .service-detail p {\n      font-size: 1rem;\n    }\n  \n    .service-detail ul li {\n      font-size: 0.9rem;\n      padding: 10px;\n    }\n  \n    .back-link {\n      font-size: 0.9rem;\n      padding: 8px 16px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .service-detail h1 {\n      font-size: 1.8rem;\n    }\n  \n    .service-detail p {\n      font-size: 0.9rem;\n    }\n  \n    .service-detail ul li {\n      font-size: 0.8rem;\n    }\n  \n    .back-link {\n      font-size: 0.8rem;\n      padding: 6px 12px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
